define.alias("shared/modifiers/perfect-scroll", "calendar/modifiers/perfect-scroll");